module.exports = __webpack_public_path__ + "static/media/promotionActive.3ffb57ae.png";